module.exports = __webpack_public_path__ + "img/Beginner-4.1726851c.png";